(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5017],{

/***/ 55017:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Hero028": function() { return /* binding */ Hero028; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var components_RichTextWidget__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(14258);
/* harmony import */ var shared_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87900);
/* harmony import */ var shared_hooks__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87367);
/* harmony import */ var _Hero028_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(46598);
/* harmony import */ var _Hero028_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_Hero028_module_scss__WEBPACK_IMPORTED_MODULE_4__);





var Hero028 = function(param) {
    var payload = param.payload, position = param.position;
    var ref, ref1;
    var ref2;
    var headline = (ref2 = payload === null || payload === void 0 ? void 0 : payload.headline) !== null && ref2 !== void 0 ? ref2 : "";
    var ref3;
    var subtitle = (ref3 = payload === null || payload === void 0 ? void 0 : payload.subtitle) !== null && ref3 !== void 0 ? ref3 : "";
    var ref4;
    var description = (ref4 = payload === null || payload === void 0 ? void 0 : payload.description) !== null && ref4 !== void 0 ? ref4 : "";
    var ref5;
    var buttonText = (ref5 = payload === null || payload === void 0 ? void 0 : (ref = payload.button) === null || ref === void 0 ? void 0 : ref.buttonText) !== null && ref5 !== void 0 ? ref5 : "";
    var ref6;
    var widgetOffset = (ref6 = payload === null || payload === void 0 ? void 0 : (ref1 = payload.button) === null || ref1 === void 0 ? void 0 : ref1.widgetOffset) !== null && ref6 !== void 0 ? ref6 : 0;
    var scrollToTarget = (0,shared_hooks__WEBPACK_IMPORTED_MODULE_3__/* .useOffsetScroll */ .VE)({
        widgetOffset: widgetOffset,
        position: position
    }).scrollToTarget;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_Hero028_module_scss__WEBPACK_IMPORTED_MODULE_4___default().wrapper),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_2__/* .Container */ .W2, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (_Hero028_module_scss__WEBPACK_IMPORTED_MODULE_4___default().content),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (_Hero028_module_scss__WEBPACK_IMPORTED_MODULE_4___default().top),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_2__/* .Heading2 */ .XJ, {
                                className: (_Hero028_module_scss__WEBPACK_IMPORTED_MODULE_4___default().headline),
                                color: "dark",
                                children: headline
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(shared_components__WEBPACK_IMPORTED_MODULE_2__/* .Action */ .aU, {
                                onClick: scrollToTarget,
                                className: (_Hero028_module_scss__WEBPACK_IMPORTED_MODULE_4___default().play),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: (_Hero028_module_scss__WEBPACK_IMPORTED_MODULE_4___default().arrow),
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_2__/* .Icon */ .JO, {
                                            className: (_Hero028_module_scss__WEBPACK_IMPORTED_MODULE_4___default().icon),
                                            name: "large_arrow_down"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_2__/* .Paragraph */ .nv, {
                                        color: "brand",
                                        appearance: "bold",
                                        children: buttonText
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (_Hero028_module_scss__WEBPACK_IMPORTED_MODULE_4___default().bottom),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_2__/* .Heading6 */ .Cd, {
                                className: (_Hero028_module_scss__WEBPACK_IMPORTED_MODULE_4___default().subtitle),
                                color: "dark",
                                children: subtitle
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_RichTextWidget__WEBPACK_IMPORTED_MODULE_1__/* .RichText */ .H, {
                                value: description,
                                className: (_Hero028_module_scss__WEBPACK_IMPORTED_MODULE_4___default().description)
                            })
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (Hero028);


/***/ }),

/***/ 46598:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Hero028_wrapper__nzA2l","top":"Hero028_top__sO9xF","bottom":"Hero028_bottom__aYc7y","headline":"Hero028_headline__XQpQw","subtitle":"Hero028_subtitle__R3d0d","description":"Hero028_description__Kf5tA","play":"Hero028_play__dDSBH","icon":"Hero028_icon__5gV2v","arrow":"Hero028_arrow___0tAD"};

/***/ })

}]);